import { render, staticRenderFns } from "./ed-nav.vue?vue&type=template&id=2a2e15cb&scoped=true&"
import script from "./ed-nav.ts?vue&type=script&lang=js&"
export * from "./ed-nav.ts?vue&type=script&lang=js&"
import style0 from "./ed-nav.scss?vue&type=style&index=0&id=2a2e15cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a2e15cb",
  null
  
)

export default component.exports